import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";

// import "jquery/dist/jquery.min.js"
// import "bootstrap/dist/js/bootstrap.min.js"

/*
 * Import Element
 */
import Element from "element-ui";
import locale from "element-ui/lib/locale/lang/es";
import "./theme/element-variables.scss";

import "./theme/main.scss";

import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from "moment-timezone";
import InfiniteLoading from "vue-infinite-loading";
import VuePaginate from "vue-paginate";
import ScrollDiv from "vue-scroll-div";

moment.tz.setDefault("America/Guayaquil");
//Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false;
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

// Element ui
// zIndex: 2205 ensures el-dialog modals open ABOVE the ipf-fullscreen preview panel (z-index: 2100)
// and above the ipf-dropdown-menu (z-index: 2200). DO NOT lower this value.
Vue.use(Element, { locale, zIndex: 2205 });

// InfiniteLoading
Vue.use(InfiniteLoading);

// VuePaginate
Vue.use(VuePaginate);

Vue.use(ScrollDiv);

import PerfectScrollbar from "vue2-perfect-scrollbar";
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";

Vue.use(PerfectScrollbar);

import VueTour from "vue-tour";
import "vue-tour/dist/vue-tour.css";

import { notifications } from "./assets/utils/notifications";
Vue.prototype.$notifications = notifications;

import SigningToastQueue from "@/components/General/SigningToastQueue";
Vue.component("SigningToastQueue", SigningToastQueue);

import CopilotModal from "@/components/Copilot/CopilotModal";
Vue.component("CopilotModal", CopilotModal);

import ExportButtons from "@/components/General/ExportButtons";
Vue.component("ExportButtons", ExportButtons);

Vue.use(VueTour);

// Permission directive
import permissionDirective from "./directives/permission";
Vue.directive("permission", permissionDirective);

// Multi-usuario: $can("perm", ...) = tiene alguno; $canOpen("ruta") = puede
// abrir esa pantalla (mismo mapa que el guard del router).
import { permissionsForRoute } from "./modules/dashboard/team/routePermissions";
Vue.prototype.$can = (...permissions) =>
  store.getters.hasAnyPermission(permissions);
Vue.prototype.$canOpen = routeName => {
  const required = permissionsForRoute(routeName);
  return !required || store.getters.hasAnyPermission(required);
};

Vue.filter("formatBoolean", function(value) {
  return value && true;
});

// --- Session activity tracking (updates on user interaction) ---
const ACTIVITY_KEY = "last_activity";
let activityThrottle = 0;
function onUserActivity() {
  const now = Date.now();
  // Throttle: update at most once every 60 seconds
  if (now - activityThrottle < 60000) return;
  activityThrottle = now;
  if (localStorage.getItem("user")) {
    localStorage.setItem(ACTIVITY_KEY, now.toString());
  }
}
["click", "keydown", "scroll", "touchstart"].forEach(evt => {
  document.addEventListener(evt, onUserActivity, { passive: true });
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
